define([
	"dojo/_base/declare",
	"csi/heading/RefImage"
], function(declare,RefImage) {

	return declare(RefImage, {
		bBaseRenderer: true,

		toTooltip: function() {
			// summary: no tooltip for header images
			return false;
		}
	});
});